import { useState, useEffect } from "react";

const useFetch = (url) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  async function fetchUrl() {
    const response = await fetch(url);
    const json = await response.json();
    setData(json);
    setLoading(false);
  }

  useEffect(() => {
    fetchUrl();
  }, []);

  return [data, loading, setData];
};

const loading = {
  "cs-CZ": "načítám ...",
  "en-GB": "loading ...",
  "fr-FR": "chargement ...",
  "de-DE": "Laden ...",
};

export { useFetch, loading };



// WEBPACK FOOTER //
// ./src/helpers/hooks.jsx